import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import bannerImage6 from "../../assets/images/bannerImage6.png";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Link } from "react-router-dom";
const useStyles = makeStyles(() => ({
  root: {
    height: "100vh",
    background: "white",
  },
  paddingStyle: {
    padding: "0px 80px",
  },

  marginBottomStyle2: {
    marginBottom: "15px",
  },

  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "4px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
    marginTop: "10px",
  },

  divStyle: {
    width: "70%",
    margin: "auto",
    "& img": {
      maxWidth: "100%",
    },
  },
}));
const ResetSuccessful = () => {
  const classes = useStyles();

  return (
    <div>
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        className={classes.root}
      >
        <Grid>
          <Header />
        </Grid>
        <Grid>
          <Grid container alignItems="center" className={classes.paddingStyle}>
            <Grid item xs={6}>
              <div
                className={classes.divStyle}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img src={bannerImage6} alt="" />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.divStyle}>
                <Typography variant="h3" className={classes.marginBottomStyle2}>
                  Success!
                </Typography>
                <Typography variant="h6" className={classes.marginBottomStyle2}>
                  Your password has been reset successfully
                </Typography>
                <Grid container alignItems="center" spacing={3}>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      component={Link}
                      to="/login"
                      variant="contained"
                      color="primary"
                      className={classes.buttonStyle}
                    >
                      LOGIN
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Footer />
        </Grid>
      </Grid>
    </div>
  );
};
export default ResetSuccessful;
